export default "__VITE_ASSET__a4fcc262__"